import axios from 'axios';

const list = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/InfoItems/`,
    withCredentials: true,
});

const item = (id) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/InfoItems/Details/${ id }`,
    withCredentials: true,
});

const update = (id, element) => {
    const data = new FormData();
    data.set('data', JSON.stringify(element));

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/InfoItems/Update/${ id }`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export default {
    list,
    item,
    update,
};
